import { useEffect, useState } from "react";
import { Filter } from "lucide-react";
import { api } from "@/lib/api";

const STEPS = [
  ["abriram", "Abriram o chat"], ["mac", "Mandaram MAC"], ["lembrete", "Receberam lembrete"],
  ["whatsapp", "Deram WhatsApp"], ["testou", "Testaram"], ["pagou", "Viraram cliente (pagou)"],
];
const PERIODS = [["today", "Hoje"], ["7d", "7 dias"], ["30d", "30 dias"]];
const pct = (v, base) => (base ? `${Math.round((v / base) * 100)}%` : "—");

const Row = ({ r, testid }) => (
  <tr data-testid={testid} className="border-t border-[#1F293D]">
    <td className="py-2 pr-3 font-semibold text-white">{r.name}</td>
    {STEPS.map(([k]) => (
      <td key={k} className="px-2 py-2 text-right">
        <span data-testid={`${testid}-${k}`} className="font-bold text-white">{r[k]}</span>
        {k !== "abriram" && <span className="ml-1 text-[11px] text-slate-500">{pct(r[k], r.abriram)}</span>}
      </td>
    ))}
  </tr>
);

export const FunnelCard = () => {
  const [period, setPeriod] = useState("7d");
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => api.get(`/chat/funnel-stats?period=${period}`).then((r) => setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [period]);

  return (
    <div data-testid="funnel-card" className="rounded-2xl border border-[#1F293D] bg-[#111827] p-4">
      <div className="mb-3 flex flex-wrap items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-lime-500/15"><Filter className="h-5 w-5 text-lime-400" /></span>
        <div className="mr-auto">
          <div className="text-sm font-bold text-white">Conversão do funil</div>
          <div className="text-[11px] text-slate-500">Chats de venda (Futmob Plus, Futzap, Pipoca) · % sobre quem abriu o chat</div>
        </div>
        <div className="flex gap-1 rounded-lg bg-[#0B1019] p-1">
          {PERIODS.map(([k, l]) => (
            <button key={k} data-testid={`funnel-period-${k}`} onClick={() => setPeriod(k)}
              className={`rounded-md px-2.5 py-1 text-xs font-semibold transition-colors ${period === k ? "bg-lime-400 text-black" : "text-slate-400 hover:text-white"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[640px] text-sm">
          <thead>
            <tr className="text-[11px] uppercase tracking-wider text-slate-500">
              <th className="pb-2 text-left font-medium">Funil</th>
              {STEPS.map(([k, l]) => <th key={k} className="px-2 pb-2 text-right font-medium">{l}</th>)}
            </tr>
          </thead>
          <tbody>
            {(d?.funnels || []).map((r) => <Row key={r.funil} r={r} testid={`funnel-row-${r.funil}`} />)}
            {d && <Row r={{ ...d.total, name: "Total" }} testid="funnel-row-total" />}
          </tbody>
        </table>
      </div>
    </div>
  );
};
